import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMemo, useImperativeHandle, forwardRef, useEffect, useRef } from 'react';
import { m, useAnimation } from 'framer-motion';
import useIsInView from '@segment/utils/useInView';
import useSliderState from './useSliderState';
import { SliderProvider, useSliderContext } from './TestimonialSliderContext';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var childVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
var contentVariants = {
  visible: {
    transition: {
      delay: 1,
      staggerChildren: 0.75
    }
  }
};
export var TestimonialSlider = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var id = _ref.id,
      delay = _ref.delay,
      slides = _ref.slides,
      _ref$initialActiveInd = _ref.initialActiveIndex,
      initialActiveIndex = _ref$initialActiveInd === void 0 ? 0 : _ref$initialActiveInd,
      externalActiveIndex = _ref.activeIndex,
      children = _ref.children,
      onSlideChange = _ref.onSlideChange,
      className = _ref.className;
  var activeIndex = externalActiveIndex !== null && externalActiveIndex !== void 0 ? externalActiveIndex : initialActiveIndex;
  var settings = useMemo(function () {
    return {
      slides: slides,
      activeSlide: activeIndex
    };
  }, [slides, activeIndex]);
  return _jsx(SliderProvider, {
    settings: settings,
    children: _jsx(WrapperComp, {
      onSlideChange: onSlideChange,
      ref: ref,
      id: id,
      delay: delay,
      slides: slides,
      className: className,
      children: children
    })
  });
});
var WrapperComp = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      onSlideChange = _ref2.onSlideChange;
  var wrapperRef = useRef(null);
  var isInView = useIsInView(wrapperRef);
  var controls = useAnimation();

  var _useSliderContext = useSliderContext(),
      activeSlide = _useSliderContext.activeSlide;

  useEffect(function () {
    onSlideChange === null || onSlideChange === void 0 ? void 0 : onSlideChange(activeSlide);
  }, [activeSlide, onSlideChange]);
  useEffect(function () {
    if (isInView) {
      controls.start("visible");
    }
  }, [controls, isInView]);
  useImperativeHandle(ref, function () {
    return wrapperRef.current;
  });
  return _jsx(m.div, {
    variants: contentVariants,
    initial: "hidden",
    animate: "visible",
    children: children
  });
});
export var Track = function Track() {
  var _useSliderState = useSliderState(),
      slides = _useSliderState.slides,
      swipe = _useSliderState.swipe,
      activeIndex = _useSliderState.activeIndex;

  var currentSlideDefinition = slides === null || slides === void 0 ? void 0 : slides[activeIndex];

  if (!currentSlideDefinition) {
    throw new Error("Slides index doesn't exists");
  }

  var CurrentSlide = currentSlideDefinition.slide,
      props = currentSlideDefinition.props;
  return _jsx(m.div, {
    drag: "x",
    dragConstraints: {
      left: 0,
      right: 0
    },
    dragMomentum: false,
    onDragEnd: function onDragEnd(_event, _ref3) {
      var offset = _ref3.offset,
          velocity = _ref3.velocity;
      swipe(offset.x, velocity.x);
    },
    variants: childVariants,
    children: _jsx(CurrentSlide, _objectSpread({}, props), activeIndex)
  });
};